/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateBannerRequest } from '../../models/create-banner-request';
import { CreateBannerResponse } from '../../models/create-banner-response';

export interface AdminServiceCreateBanner$Params {
      body: CreateBannerRequest
}

export function adminServiceCreateBanner(http: HttpClient, rootUrl: string, params: AdminServiceCreateBanner$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateBannerResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceCreateBanner.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateBannerResponse>;
    })
  );
}

adminServiceCreateBanner.PATH = '/api/v3/gateway/admin/banner';
